'use client'

import Link from 'next/link'
import Image from 'next/image'
import dynamic from 'next/dynamic'
import { Grid, Typography, Divider } from '@mui/material'

// Types
import type { CardProps } from '@/types/components/molecules/cards'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

// Components
const BrownButtonAtom = dynamic(() => import('@/components/atoms/buttons/brown'))

const CardMolecule = (props: CardProps) => {
	// Props
	const { lng, title, image, link, subtitle, year, description, coverImage, size } = props

	// Variables
	const { t } = useTranslation(lng)

	return (
		<Grid size={{ xs: 12, md: size === 'small' ? 4 : size === 'medium' ? 6 : 12 }}>
			<Link href={`/${lng}${link}`}>
				<Grid container direction="column" alignItems="stretch" spacing={2.5} position="relative" height={{ md: 1 }} p={1.5} bgcolor="#fefcf8" borderRadius={2}>
					{image && (
						<Grid
							display="inline-flex"
							size={12}
							borderRadius={1}
							overflow="hidden"
							sx={{
								'& img': {
									width: 1,
									height: { xs: 180, md: size === 'small' ? 240 : size === 'medium' ? 280 : 360 },
									objectFit: 'cover',
									objectPosition: 'center'
								}
							}}
						>
							<Image src={`/api/download${size === 'large' && coverImage ? coverImage : image}`} alt={title ?? ''} width={544} height={360} />
						</Grid>
					)}

					<Grid size={12} mb={7} px={1.75}>
						{title && (
							<Grid container>
								<Typography component="h3" fontSize={26} fontWeight={700} lineHeight={1.25} color="common.black">
									{title}
								</Typography>
							</Grid>
						)}

						{(year || subtitle) && (
							<Grid container alignItems="center" spacing={2} mt={1.75}>
								{year && (
									<Grid size="auto">
										<Typography component="div" fontSize={26} lineHeight={1.25} color="#3b4a7f">
											{year}
										</Typography>
									</Grid>
								)}

								{year && subtitle && <Divider orientation="vertical" flexItem sx={{ my: 0.5, bgcolor: 'secondary.main' }} />}

								{subtitle && (
									<Grid size="grow">
										<Typography component="div" fontSize={16} lineHeight={1.25} color="secondary.main">
											{subtitle}
										</Typography>
									</Grid>
								)}
							</Grid>
						)}

						{description && (
							<Grid container mt={1}>
								<Typography variant="body2" lineHeight={1.25} color="common.black">
									{description}
								</Typography>
							</Grid>
						)}

						<Grid container direction="row-reverse" width={1} position="absolute" bottom={0} left={0} mt={1} p={2.5} pt={0}>
							<Grid size="auto">
								<BrownButtonAtom>{t('form:button.explore')}</BrownButtonAtom>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Link>
		</Grid>
	)
}

export default CardMolecule
